import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectEntitiesByFilters } from '../../../shared/store/views/entityView';
import { useNavigate } from 'react-router';
import { emergencyFiltersByLang } from '../../../shared/utils/entitiesFiltersUtils';
import { usePermission } from '../../../shared/hooks/usePermission';
import PageHeader from '../../../shared/components/features/PageHeader.js/PageHeader';
import iconsList from '../../../shared/components/ui/icons/iconsList';
import pathRouts from '../../../shared/enums/pathRoute';
import GoogleMeetSection from './googleMeetSection/GoogleMeetSection';
import Page from '../../../shared/components/ui/page/Page';
import BannerItem from '../../../shared/components/features/BannerItem/BannerItem';
import CourseGallery from '../../../shared/components/features/courseGallery/CourseGallery';
import classes from './GoogleMeetPage.module.css';

const GoogleMeetPage = () => {

    const navigate = useNavigate();
    const { texts, lang } = useSelector(state => state.translate);
    const general = useSelector(state => state.uiData.general);
    const emergencyFilters = useMemo(() => emergencyFiltersByLang(lang), [lang]);
    const emergencyCourses = useSelector(state => selectEntitiesByFilters(state, emergencyFilters));
    const galleryBanner = general?.googleMeet?.galleryBanner;
    const educationLetterBanner = general?.googleMeet?.educationLetterBanner;
    const tehudaBanner = general?.googleMeet?.tehudaBanner;
    const hasPermission = usePermission();

    return (
        <Page
            title={texts.googleMeet}
            icon={iconsList.googleMeet}
            onBack={() => navigate(`/${pathRouts.HOME}`)}
        >
            <div className={classes.GoogleMeetPage}>
                <PageHeader text={texts.googleMeet} color="FFF" />
                <div className={classes.TopLineBanners}>
                    <BannerItem
                        className={classes.MeetBanner}
                        banner={{
                            img: galleryBanner?.img?.[lang],
                            link: galleryBanner?.link?.[lang],
                            color: galleryBanner?.color,
                            imgWidth: galleryBanner?.imgWidth,
                            text: galleryBanner?.text,
                        }} />
                    <BannerItem
                        className={classes.MeetBanner}
                        banner={{
                            img: educationLetterBanner?.img?.[lang],
                            link: window.config.educationLetterLink?.[lang],
                            color: educationLetterBanner?.color,
                            imgWidth: educationLetterBanner?.imgWidth,
                            text: educationLetterBanner?.text,
                        }} />
                    <BannerItem
                        className={classes.MeetBanner}
                        banner={{
                            img: tehudaBanner?.img?.[lang],
                            link: tehudaBanner?.link?.[lang],
                            color: tehudaBanner?.color,
                            imgWidth: tehudaBanner?.imgWidth,
                            text: tehudaBanner?.text,
                        }} />
                </div>
                <div className={classes.Content}>
                    <div className={classes.MeetSection}>
                        <GoogleMeetSection />
                    </div>
                    <div className={classes.Banners}>
                        {general?.googleMeet?.Banners?.map((banner, index) => (
                            (!banner?.permission || hasPermission(banner?.permission)) &&
                            <BannerItem
                                key={index}
                                className={classes.MeetBanner}
                                banner={{
                                    img: banner.img?.[lang],
                                    link: banner.link?.[lang],
                                    color: banner.color,
                                    imgWidth: banner.imgWidth,
                                    text: banner.text,
                                }}
                            />
                        ))}
                    </div>
                    <div className={classes.Gallery}>
                        <CourseGallery
                            courses={emergencyCourses}
                            title={texts.emergencyLearning}
                            description={texts.emergencyLearningDescription}
                        />
                    </div>
                </div>
            </div>
        </Page>
    );
};

export default GoogleMeetPage;
